module.exports = __webpack_public_path__ + "img/profession.c7557be8.jpg";